import { getters } from "@/constants/state";

export default {
  [getters.SPECIALJOB_LATEST_GETTER]: (state) => state.latest,
};
